import { Injectable } from "@angular/core";
import { HttpService } from "./http.service";

@Injectable({
	providedIn: "root"
})
export class FormsService {

	constructor(
		private http: HttpService
	) { }
	saveField(data: any) {
		return new Promise((resolve, reject) => {
			this.http.post("api/fields/fields/saveField", true, data).then(res => {
				resolve(res);
			}).catch(err => reject());
		});
	}
	getFields(data: any) {
		return new Promise((resolve, reject) => {
			this.http.post("api/forms/forms/getFields", true, data).then(res => {
				resolve(res);
			}).catch(err => reject());
		});
	}
	getById(data: any): any {
		return new Promise((resolve, reject) => {
			this.http.post("api/forms/forms/getById", true, data).then(res => {
				resolve(res);
			});
		});
	}
}
